import React from 'react'
import SearchBox from './SearchBox';

export default class SearchForm extends React.Component {
    constructor(props) {
        super(props);
    }

    submitSearch = (r) => {
        window.location.href = '/rental_cars/?' +
            'start_date=' + r.start_date +
            '&end_date=' + r.end_date +
            '&start_location=' + r.start_location +
            '&end_location=' + r.end_location +
            '&start_hour=' + r.start_hour +
            '&end_hour=' + r.end_hour +
            '&locale=' + this.props.locale
    }

    render() {
        return (
            <div className={'row'}>
                <div className={'col'}>
                    <SearchBox {...this.props}
                               submitSearch={(r) => this.submitSearch(r)}/>
                </div>
            </div>
        )
    }
}